var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"frameBed"}},[_c(_vm.$route.params.id,{tag:"component",on:{"hook:mounted":_vm.componentMounted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }